/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Images
import console from '../images/panel/console.webp'

const Panel = () => {
    return (
        <section className="panel py-28">
            <div className="max-w-7xl mx-auto px-5 sm:px-5 lg:px-5">
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 items-center">
                    <div className="mb-16 sm:md-16 md:mb-0 lg:mb-0">
                        <h1 className="text-purple-500 text-lg font-semibold uppercase mb-2">Game Panel</h1>
                        <h2 className="text-gray-300 text-3xl font-bold mb-2.5">Check out our Game Panel</h2>
                        <p className="text-gray-300 mb-8">Manage your Game Server with ease using Pterodactyl Panel</p>
                        <div className="features mb-8">
                            <div className="flex items-center mb-2.5">
                                <div className="flex items-center w-44">
                                    <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </span>
                                    <p className="text-gray-300 text-base ml-4">Console</p>
                                </div>
                                <div className="ml-2 flex items-center">
                                    <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </span>
                                    <p className="text-gray-300 text-base ml-4">Sub-users</p>
                                </div>
                            </div>
                            <div className="flex items-center">
                                <div className="flex items-center w-44">
                                    <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </span>
                                    <p className="text-gray-300 text-base ml-4">Databases</p>
                                </div>
                                <div className="ml-2 flex items-center">
                                    <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </span>
                                    <p className="text-gray-300 text-base ml-4">Automatic Backups</p>
                                </div>
                            </div>
                        </div>
                        <p className="text-gray-300">...and much more!</p>
                    </div>
                    <div>
                        <img src={console} className="ml-auto rounded-md" alt='Console' />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Panel